export default __webpack_public_path__ + "static/media/04_DAIF_Infra_01_01.0b341834.mp4";